var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"circle",staticStyle:{"animation-delay":"0s"}}),_c('div',{staticClass:"circle",staticStyle:{"animation-delay":"2s"}})])
}]

export { render, staticRenderFns }